import styled from 'styled-components'
import { WHEEL_SIZE } from './colorWheel'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
`

export const WheelCanvas = styled.canvas`
  border-radius: 50%;
  border: 1px solid ${({ theme: { colors } }) => colors('highlight', 0.25)};
  cursor: crosshair;
  display: block;
  width: ${WHEEL_SIZE}px;
  height: ${WHEEL_SIZE}px;
  flex-shrink: 0;
`

export const SliderLabel = styled.div`
  color: ${({ theme: { colors } }) => colors('highlight', 0.45)};
  font-size: 0.55rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.2rem;
`

export const BrightnessTrack = styled.div`
  position: relative;
  height: 12px;
  border-radius: 2px;
  background: ${({ from, to }) => `linear-gradient(to right, ${from}, ${to})`};
  border: 1px solid ${({ theme: { colors } }) => colors('highlight', 0.2)};
  cursor: pointer;
`

export const BrightnessThumb = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid rgba(0,0,0,0.5);
  box-shadow: 0 1px 3px rgba(0,0,0,0.5);
  pointer-events: none;
  ${({ left }) => `left: ${left}%;`}
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  min-width: 0;
`

export const Swatch = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 3px;
  border: 1px solid ${({ theme: { colors } }) => colors('highlight', 0.3)};
  flex-shrink: 0;
  ${({ color }) => `background: ${color};`}
`

export const HexInput = styled.input`
  flex: 1;
  min-width: 0;
  background: transparent;
  border: 1px solid ${({ theme: { colors } }) => colors('highlight', 0.2)};
  color: ${({ theme: { colors } }) => colors('highlight', 0.7)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.65rem;
  padding: 0.25rem 0.4rem;
  letter-spacing: 0.05em;
  outline: none;
  border-radius: 2px;
  &:focus { border-color: ${({ theme: { colors } }) => colors('highlight', 0.5)}; }
`

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  background: ${({ $active, theme: { colors } }) =>
    $active ? colors('highlight', 0.18) : 'transparent'};
  border: 1px solid ${({ $active, theme: { colors } }) =>
    $active ? colors('highlight', 0.6) : colors('highlight', 0.2)};
  color: ${({ $active, theme: { colors } }) =>
    $active ? colors('highlight') : colors('highlight', 0.55)};
  cursor: pointer;
  border-radius: 2px;
  &:hover {
    background: ${({ theme: { colors } }) => colors('highlight', 0.12)};
    color: ${({ theme: { colors } }) => colors('highlight')};
    border-color: ${({ theme: { colors } }) => colors('highlight', 0.4)};
  }
`
